import axios from "axios";
import { BASE_URL } from "../../Config/BaseUrl";

const token = localStorage.getItem("token");

const createAxiosConfig = (url, method, data) => {
  return {
    method,
    url: `${BASE_URL}${url}/`,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    data,
  };
};

export const PayrollSettings = {
    addUpdatePayrollSetting: async (data) => {
    const axiosConfig = createAxiosConfig(
      "add_update_payroll_setting",
      "POST",
      data
    );
    return await axios(axiosConfig)
  },
  getpayrollSetting: async (data) => {
    const axiosConfig = createAxiosConfig(
      "get_payroll_setting",
      "POST",
      data
    );
    return await axios(axiosConfig)
  },
};